export const removeTrackerPopup = {
  title: 'この項目を削除しますか?',
  content:
    '削除しますか?一度削除すると復元できません<br /><checkbox>一度削除すると元に復元できないことを理解した上で、削除します。</checkbox>',
  ok: '了解',
  cancel: 'キャンセル',
};

export default removeTrackerPopup;
